<nav
  class="primary-navigation"
  aria-label="Navegación principal"
  [class.primary-navigation-collapsed]="desktopCollapsed()"
>
  @if (!temporary()) {
    <div class="navigation-controls">
      <button
        mat-icon-button
        type="button"
        class="navigation-collapse-control"
        [attr.aria-label]="desktopCollapsed() ? 'Expandir navegación' : 'Colapsar navegación'"
        [matTooltip]="desktopCollapsed() ? 'Expandir navegación' : 'Colapsar navegación'"
        (click)="toggleCollapsed()"
      >
        <span class="navigation-control-icon" aria-hidden="true">
          {{ desktopCollapsed() ? '»' : '«' }}
        </span>
      </button>
    </div>
  }

  <ul class="navigation-list">
    @for (item of visibleItems(); track item.id) {
      @if (item.children?.length) {
        <li class="navigation-group" [class.navigation-group-active]="isGroupActive(item)">
          @if (desktopCollapsed()) {
            <button
              #groupMenuTrigger="matMenuTrigger"
              mat-icon-button
              type="button"
              class="navigation-group-trigger navigation-icon-button"
              [matMenuTriggerFor]="groupMenu"
              [matTooltip]="item.label"
              [attr.aria-label]="item.label"
              [attr.aria-expanded]="groupMenuTrigger.menuOpen"
            >
              <span class="navigation-icon" aria-hidden="true">{{ item.icon }}</span>
            </button>

            <mat-menu #groupMenu="matMenu" class="navigation-group-menu">
              <div class="navigation-menu-heading" aria-hidden="true">{{ item.label }}</div>
              @for (child of item.children; track child.id) {
                @if (child.route) {
                  <a
                    mat-menu-item
                    class="navigation-menu-link"
                    [routerLink]="child.route"
                    routerLinkActive="navigation-menu-link-active"
                    ariaCurrentWhenActive="page"
                    (click)="select(child)"
                  >
                    <span class="navigation-icon" aria-hidden="true">{{ child.icon }}</span>
                    <span>{{ child.label }}</span>
                  </a>
                }
              }
            </mat-menu>
          } @else {
            <button
              type="button"
              class="navigation-group-label"
              [attr.aria-expanded]="isGroupExpanded(item.id)"
              [attr.aria-controls]="'navigation-group-' + item.id"
              (click)="toggleGroup(item.id)"
            >
              <span class="navigation-icon" aria-hidden="true">{{ item.icon }}</span>
              <span class="navigation-label">{{ item.label }}</span>
              <span
                class="navigation-group-chevron"
                [class.navigation-group-chevron-collapsed]="!isGroupExpanded(item.id)"
                aria-hidden="true"
              >
                ⌄
              </span>
            </button>

            @if (isGroupExpanded(item.id)) {
              <ul class="navigation-children" [id]="'navigation-group-' + item.id">
                @for (child of item.children; track child.id) {
                  @if (child.route) {
                    <li>
                      <a
                        class="navigation-link navigation-child-link"
                        [routerLink]="child.route"
                        routerLinkActive="navigation-link-active"
                        ariaCurrentWhenActive="page"
                        (click)="select(child)"
                      >
                        <span class="navigation-icon" aria-hidden="true">{{ child.icon }}</span>
                        <span class="navigation-label">{{ child.label }}</span>
                      </a>
                    </li>
                  }
                }
              </ul>
            }
          }
        </li>
      } @else if (item.route) {
        <li>
          <a
            class="navigation-link"
            [class.navigation-icon-button]="desktopCollapsed()"
            [routerLink]="item.route"
            routerLinkActive="navigation-link-active"
            [routerLinkActiveOptions]="{ exact: item.route === '/' }"
            ariaCurrentWhenActive="page"
            [attr.aria-label]="desktopCollapsed() ? item.label : null"
            [matTooltip]="desktopCollapsed() ? item.label : ''"
            [matTooltipDisabled]="!desktopCollapsed()"
            (click)="select(item)"
          >
            <span class="navigation-icon" aria-hidden="true">{{ item.icon }}</span>
            @if (!desktopCollapsed()) {
              <span class="navigation-label">{{ item.label }}</span>
            }
          </a>
        </li>
      }
    }
  </ul>
</nav>
